export { EQUIPMENT_INPUTS_LIST } from './equipment.constants';
// export { MEDICAL_OFFICES_INPUTS_LIST } from './medicalOffices.constants';
export { SPECIALTIES_CHECKBOXES_LIST } from './specialties.constants';
// export { HR_INPUTS_LIST } from './hr.constants';
export { KEY_PERSONNEL_INPUTS_LIST } from './keyPersonnel.constants';
